import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';

import cardsReducer from './cards/cardsSlice';
import clientConfigurationReducer from './clientConfiguration/clientConfigurationSlice';
import commentsReducer from './comments/commentsSlice';
import customersReducer from './customers/customersSlice';
import destPointReducer from './destPoint/destPointSlice';
import driversReducer from './drivers/driversSlice';
import historyReducer from './history/historySlice';
import identityReducer from './identity/identitySlice';
import ivazReducer from './ivaz/ivazSlice';
import licensesReducer from './licenses/licensesSlice';
import productsReducer from './products/productsSlice';
import reportsReducer from './reports/reportsSlice';
import resultsReducer from './results/resultsSlice';
import rootReducer from './rootReducer';
import rootSaga from './rootSaga';
import settingsReducer from './settings/settingsSlice';
import toastReducer from './toast/toastSlice';
import vehiclesReducer from './vehicles/vehiclesSlice';
import weightingsReducer from './weightings/weightingsSlice';

const sagaMiddleware = createSagaMiddleware();

const store = configureStore({
 reducer: {
  results: resultsReducer.reducer,
  identity: identityReducer.reducer,
  toast: toastReducer,
  clientConfiguration: clientConfigurationReducer,
  comments: commentsReducer,
  reports: reportsReducer,
  ivaz: ivazReducer,
  history: historyReducer,
  customers: customersReducer.reducer,
  vehicles: vehiclesReducer.reducer,
  weightings: weightingsReducer.reducer,
  drivers: driversReducer.reducer,
  products: productsReducer.reducer,
  destPoint: destPointReducer.reducer,
  cards: cardsReducer.reducer,
  settings: settingsReducer.reducer,
  licenses: licensesReducer.reducer,
 },
 middleware: (getDefaultMiddleware) =>
  getDefaultMiddleware().concat(sagaMiddleware),
});

sagaMiddleware.run(rootSaga);

export type RootState = ReturnType<typeof rootReducer>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;

export default store;

